const createComponentModule = require('../../../common/utils/createComponentModule');

const getInputLength = (input) => input.value.length;

const createHandleInput = (counterElement) => (evt) => {
  const numChars = getInputLength(evt.target);
  // Is not a reassign, displaying the result
  // eslint-disable-next-line no-param-reassign
  counterElement.innerHTML = numChars;
};

const getMaxLength = (textarea) =>
  /^[0-9]+$/.test(textarea.getAttribute('maxlength'))
    ? parseInt(textarea.getAttribute('maxlength'), 10)
    : -1;

module.exports = createComponentModule(
  '.field-textarea',
  (fieldTextareaComponent) => {
    const textarea = fieldTextareaComponent.querySelector(
      '.field-textarea__textarea'
    );

    // Does textarea need a counter?
    const maxLength = getMaxLength(textarea);
    if (maxLength > 0) {
      // Counter
      const length = getInputLength(textarea);
      const counter = document.createElement('p');
      counter.classList.add('field-textarea__counter');
      counter.innerHTML = `<span class="field-textarea__counter-length">${length}</span>/${maxLength}`;
      const counterCurrentLength = counter.querySelector(
        '.field-textarea__counter-length'
      );

      // Look for element to insert after
      const insertAfterThisElement = textarea.nextElementSibling.matches(
        'label'
      )
        ? textarea.nextElementSibling
        : textarea;

      // Insert new counter element
      fieldTextareaComponent.insertBefore(
        counter,
        insertAfterThisElement.nextElementSibling
      );

      // Update counter
      const handleInput = createHandleInput(counterCurrentLength);
      textarea.addEventListener('keyup', handleInput);
    }
  }
);
